
export const SET_LANGUAGES = 'languages/set-languages';
export const SET_LANGUAGE_ACTIVE = 'languages/set-language-active';
